import React from "react";
// @ts-ignore
import "./WhySection.css";

interface Reason {
  icon: string;
  title: string;
  desc: string;
}

const reasons: Reason[] = [
  {
    icon: "fa-clock",
    title: "Trip Planning",
    desc: "Tell us your plans and we'll walk through the car, pricing, and reservation details with you.",
  },
  {
    icon: "fa-user-tie",
    title: "Professional Service",
    desc: "Professional drivers focused on clear communication and passenger care.",
  },
  {
    icon: "fa-car",
    title: "Vehicle Options",
    desc: "We match the right car to your group, luggage, destination, and timing.",
  },
  {
    icon: "fa-headset",
    title: "Flexible Scheduling",
    desc: "Tell us your dates and pickup window so we can check current scheduling.",
  },
  {
    icon: "fa-tag",
    title: "Clear Quote",
    desc: "Your estimate reflects the route, car, timing, and any extras we agree on.",
  },
  {
    icon: "fa-star",
    title: "A Luxury Experience",
    desc: "From the moment you book to the moment you arrive, the ride should feel effortless.",
  },
];

export default function WhySection(): JSX.Element {
  return (
    <section className="why-section py-5">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-lg-5 gs-anim">
            <span className="section-badge">Why Choose Us</span>
            <h2 className="section-title">The GS Limo Elite Difference</h2>
            <p className="why-lead">
              Share your itinerary and we'll go over the car, pricing, and
              current travel details with you.
            </p>
            <div className="why-stat-row">
              <div className="why-stat">
                <div className="why-stat-num">After review</div>
                <div className="why-stat-label">Availability</div>
              </div>
              <div className="why-stat">
                <div className="why-stat-num">Before booking</div>
                <div className="why-stat-label">Pricing</div>
              </div>
              <div className="why-stat">
                <div className="why-stat-num">Before travel</div>
                <div className="why-stat-label">Pickups</div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="row g-3">
              {reasons.map((r, i) => (
                <div className="col-sm-6 gs-anim" key={i}>
                  <div className="why-card">
                    <div className="why-icon">
                      <i className={`fas ${r.icon}`}></i>
                    </div>
                    <div>
                      <h3 className="why-card-title">{r.title}</h3>
                      <p className="why-card-desc">{r.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
